import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useBackNavigate } from "core/utils/helper";
import { useGetLang } from "../hooks";
import { useCallback, useEffect, useState } from "react";
import { TypeEnumPolicy } from "core/config/constant";
import API from "core/networks/API";
import { API_GET_CONTENT_POLICY } from "../api";
import { _t } from "core/language";

const ContentPolicyAgreeInfo = () => {
  const navigateToBack = useBackNavigate();

  const { langId } = useGetLang();
  const [contentPolicy, setContentPolicy] = useState("");

  const handleGetContentPolicy = useCallback(async () => {
    const dataRequest = {
      lang_id: langId,
      type: TypeEnumPolicy.PERSONAL_INFORMATION_HANDLING_POLICY,
    };

    try {
      const { data: response } = await API.get(
        `${API_GET_CONTENT_POLICY}`,
        dataRequest
      );
      if (response && response?.code === 200) {
        const content =
          response?.data && response?.data.length > 0
            ? response?.data[0].content
            : "";
        setContentPolicy(content);
      }
    } catch (e: any) {
      console.log(e, "errors");
    }
  }, [langId]);

  useEffect(() => {
    handleGetContentPolicy();
  }, [handleGetContentPolicy]);


  return (
    <AppLayout className={"content-policy-client-page"}>
      <PageHeader
        sticky
        title={_t("auth.LabelPrivacyPolicy")}
        showCart={false}
        handleGoBack={() => navigateToBack()}
      />

      <div className="px-4 mt-[38px] mb-3">
        <h1 className="self-start text-base font-medium tracking-tighter text-neutral-900">
            {_t("menu.AppName")}
          </h1>
        <div className=" px-3.5 py-5 mt-3.5 text-sm tracking-tighter rounded-lg bg-[#F4F4F4] mb-[65px] min-h-[50vh]">
          <div dangerouslySetInnerHTML={{ __html: contentPolicy }} />
        </div>
        
      </div>
    </AppLayout>
  );
};

export default ContentPolicyAgreeInfo;
